import i18n from '@/plugins/i18n';
import store from '@/store';

function handleCredentialResponse({ state, credential }) {
    if (!state) {
        console.error('Google Sign In: state not found in the rendered button');
        return;
    }
    store.commit('guest/setGoogleSignInResponse', { state, credential });
}

export default {
    async install(Vue) {
        Vue.prototype.$gAuth = {
            renderButton(el, options) {
                const defaultOptions = {
                    text: 'continue_with',
                    size: 'large',
                    theme: 'outline',
                    logo_alignment: 'center',
                    shape: 'rectangular',
                    type: 'standard',
                    width: el.parentElement?.offsetWidth,
                    auto_select: true,
                    locale: i18n.locale,
                };
                window.google.accounts.id.renderButton(el, {
                    ...defaultOptions,
                    ...options,
                });
            },
        };
        let isInitialized;
        try {
            if (process.env.VUE_APP_GOOGLE_CLIENT_ID) {
                await Vue.loadScript(
                    'https://accounts.google.com/gsi/client?hl=en'
                );
                window.google.accounts.id.initialize({
                    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
                    callback: handleCredentialResponse,
                });
                isInitialized = true;
            } else {
                isInitialized = false;
                console.warn('Google Sign In: GOOGLE_CLIENT_ID not found');
            }
        } catch (error) {
            isInitialized = false;
            console.error(error);
        }
        store.commit('guest/setIsGoogleSignInInitialized', isInitialized);
    },
};
